<template>
  <div class="module no-header no-footer mt-4">
    <CRoomSize
      :minHeight="minHeight"
      :maxHeight="maxHeight"
      :minWidth="minWidth"
      :maxWidth="maxWidth"
      :currentHeight="currentHeight"
      :currentWidth="currentWidth"
      :withScales="withScales"
      :unit="unit"
      @RoomSizeChanged="emitRoomSizeChanged"
      @WithScalesChanged="emitWithScalesChanged"
      @ContextualHelpChanged="emitContextualHelpChanged"
      @UnitChanged="emitUnitChanged"
    ></CRoomSize>

    <CIdxVisualisation 
      class="mt-4"
      :idx="idx"
      :currentHeight="currentHeight"
      :currentWidth="currentWidth"
      @RoomSizeChanged="emitRoomSizeChanged"
      @ContextualHelpChanged="emitContextualHelpChanged"
    ></CIdxVisualisation>
  </div>
</template>

<script>
import CRoomSize from "@/components/subPlacement/CRoomSize.vue";
import CIdxVisualisation from "@/components/subPlacement/CIdxVisualisation.vue";
export default {
  name: "CSettings",
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  components: {
    CRoomSize,
    CIdxVisualisation
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  props: {
    currentHeight: Number,
    currentWidth: Number,
    idx: Number,
    withScales: Boolean,
    unit: String
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  data () {
    return {
      minHeight: 200,
      maxHeight: 514,
      minWidth: 300,
      maxWidth: 771,
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  methods: {
    emitRoomSizeChanged: function(event) {
      this.$emit("RoomSizeChanged", event);
    },
    //////////////////////////////////////////////////////////////////
    emitWithScalesChanged: function(event) {
      this.$emit("WithScalesChanged", event);
    },
    //////////////////////////////////////////////////////////////////
    emitContextualHelpChanged: function(event) {
      this.$emit("ContextualHelpChanged", event);
    },
    //////////////////////////////////////////////////////////////////
    emitUnitChanged: function(event) {
      this.$emit("UnitChanged", event);
    }
  }
}
</script>

<style lang="scss" scoped>
  @include setModule(75vh, false, false, 0);
</style>